// @ts-nocheck
import styled from 'styled-components';

export const HorizontalCardContainer = styled.div`
  img,
  source,
  picture {
    opacity: 1;
  }
  transition: 500ms;
  ${({ theme }) => theme.breakpoints.up('md')} {
    max-height: 212px;
    img,
    source,
    picture {
      opacity: 0.9;
      transition: opacity 0.5s ease;
    }
    :hover {
      box-shadow: 0px 8px 18px rgba(92, 84, 122, 0.1);
      img,
      source,
      picture {
        opacity: 1;
      }
    }
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    height: fit-content;
  }
`;

export const ImageWrapper = styled.a`
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  @media (min-width: 375px) {
    width: 96px;
    min-width: 96px;
    max-width: 96px;
  }
  height: 96px;
  min-height: 96px;
  max-height: 96px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 205px;
    min-width: 205px;
    max-width: 205px;
    height: 140px;
    min-height: 140px;
    max-height: 140px;
  }
`;
